import React from "react";

import { Link } from "../LandingPageLinks";

import css from "./TopBuyers.module.scss";

type Props = {
  weighted_buyers: Link[];
};

export default function TopBuyers({ weighted_buyers }: Props) {
  return (
    <div className={css.topBuyers}>
      <h3>Explore top buyers for public sector contracts</h3>
      <p>
        Discover open tenders, contract awards and upcoming contract expiries of thousands of public
        sector buyers below. Gain insights into their procurement activity, historical purchasing
        trends and more.
      </p>
      <div className={css.buyers}>
        {weighted_buyers.map((buyer) => (
          <a key={buyer.path} href={buyer.path}>
            {buyer.text}
          </a>
        ))}
      </div>
      <a href="/explore/search/buyers">Explore over 15,000 buyers</a>
    </div>
  );
}
